import { api } from "./api";

const depositApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDepositInfo: builder.query({
      query: () => "bankdeposit",
      providesTags: ["bankdeposit"],
    }),
    addDepositInfo: builder.mutation({
      query: (newCategory) => ({
        url: "bankdeposit",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["bankdeposit"],
    }),
    removeDepositInfo: builder.mutation({
      query: (id) => ({
        url: `bankdeposit/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["bankdeposit"],
    }),
    editDepositInfo: builder.mutation({
      query: (editData) => ({
        url: `bankdeposit`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["bankdeposit"],
    }),
  }),
});

export const {
  useGetDepositInfoQuery,
  useAddDepositInfoMutation,
  useRemoveDepositInfoMutation,
  useEditDepositInfoMutation,
} = depositApi;